// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"44d56654","787":"14ab5620"}[chunkId] + ".chunk.js";
};